import React from 'react';
import LuckyWheelForm from './form';
import {notification} from 'antd';
import history from '../../modules/History';
import {addLuckyWheel} from '../../modules/Api';

class AddLuckyWheel extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false,
        }

    }

    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        addLuckyWheel(values, (res) => {
            this.setState({submitted:false});

            if(res.status==200){
                notification.open({
                    message: `اطلاعات با موفقیت ویرایش شد!`,
                });
                history.item.push(`/lucky_wheels`);
            }
            else if(res.message != undefined){
                notification.open({
                    message: res.message,
                });
            }
        });
    }
    render() {
        return (<LuckyWheelForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/>);
    }
}

export default AddLuckyWheel;


// WEBPACK FOOTER //
// ./src/containers/LuckyWheels/add.js